/**
 * CommunityPage — 同行 (Generosity) Tab
 *
 * Coming Soon 占位页面
 */
import { Sprout } from 'lucide-react';
import { ComingSoonPage } from '../../components/ComingSoonPage';

export default function CommunityPage() {
  return (
    <ComingSoonPage
      title="同行"
      tagline="数据共建 · 互助成长 · 同行不孤"
      icon={Sprout}
      theme="clay"
    />
  );
}
